import React from "react";
import type { AnswerState, Exercise } from "../../types/exercises";
import { MatchWords } from "./MatchWords";
import { MatchPicture } from "./MatchPicture";
import { MatchAudio } from "./MatchAudio";
import { FillGap } from "./FillGap";
import { MemoryCards } from "./MemoryCards";
import { Pronounce } from "./Pronounce";
import { Rearrange } from "./Rearrange";
interface ExerciseViewProps {
  exercise: Exercise;
  checked: boolean;
  onAnswer: (a: AnswerState) => void;
  speechLang: string;
}
export const exerciseHeadings: Record<Exercise["type"], string> = {
  "match-words": "Match the pairs",
  "match-picture": "Pick the right picture",
  "match-audio": "What do you hear?",
  "fill-gap": "Fill in the gap",
  memory: "Find the matching pairs",
  pronounce: "Say it out loud",
  rearrange: "Put the words in order"
};
export function ExerciseView({
  exercise,
  checked,
  onAnswer,
  speechLang
}: ExerciseViewProps) {
  switch (exercise.type) {
    case "match-words":
      return <MatchWords exercise={exercise} onAnswer={onAnswer} speechLang={speechLang} data-id="element-293" data-mp="1rb48o23v9dop" />;
    case "match-picture":
      return <MatchPicture exercise={exercise} onAnswer={onAnswer} checked={checked} speechLang={speechLang} data-id="element-294" data-mp="1md2pziacrgdr" />;
    case "match-audio":
      return <MatchAudio exercise={exercise} onAnswer={onAnswer} checked={checked} speechLang={speechLang} data-id="element-295" data-mp="210e2bmecz4ex" />;
    case "fill-gap":
      return <FillGap exercise={exercise} onAnswer={onAnswer} checked={checked} data-id="element-296" data-mp="18cibgybh06q2" />;
    case "memory":
      return <MemoryCards exercise={exercise} onAnswer={onAnswer} speechLang={speechLang} data-id="element-297" data-mp="13dougvwz5xl5" />;
    case "pronounce":
      return <Pronounce exercise={exercise} onAnswer={onAnswer} checked={checked} speechLang={speechLang} data-id="element-298" data-mp="1hdpxagwsvf39" />;
    case "rearrange":
      return <Rearrange exercise={exercise} onAnswer={onAnswer} checked={checked} data-id="element-299" data-mp="1datg8umwrr1f" />;
  }
}